/*###########################################################################
// Components
//#########################################################################*/

/* Dynamic Components
//------------------*/

const initDynamicComponents = () => {
	if (document.querySelector('.accordion')) {
		import('./_accordions')
	}

	if (document.querySelector('.copy-clipboard')) {
		import('./_copyClipboard')
	}

	if (document.querySelector('.scroller')) {
		import('./_scroller')
	}

	if (document.querySelector('.scrollerGallery')) {
		import('./_scrollerGallery')
	}

	if (document.querySelector('.services--sticky')) {
		import('./_services')
	}

	if (document.querySelector('.sliderCaseStudies')) {
		import('./_sliderCaseStudies')
	}

	if (document.querySelector('.sliderGallery')) {
		import('./_sliderImageGallery')
	}

	if (document.querySelector('.sliderLogoBar')) {
		import('./_sliderLogoBar')
	}

	if (document.querySelector('.sliderTeamCards')) {
		import('./_sliderTeamCards')
	}

	if (document.querySelector('.sprigFilter')) {
		import('./_sprigFilter')
	}

	if (document.querySelector('.themeSelect')) {
		import('./_themeSelect')
	}
}

initDynamicComponents()

window.addEventListener('page-change', function() {
	initDynamicComponents()
})

/* Standard Components
//------------------*/

import './_browserDetect'
import './_cursor'

//import './_contactForm'
import './_forms'
import './_heroHome'
import './_hScreenCalc'
import './_lazyImagesScrollTrigger'
import './_modals'
import './_responsiveVideo'
import './_reveal'
import './_scrollTo'
